import { ExcellentQuality } from './ExcellentQuality/ExcellentQuality';
import { PoorQuality } from './PoorQuality/PoorQuality';
import { getQualityScore } from './getQualityScore/getQualityScore';
import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { QualityModal } from './QualityModal/QualityModal';
import { useState } from 'react';
import { PreflightTestReport } from '../../AppStateProvider/AppStateProvider';
import { PreflightTest } from '@twilio/voice-sdk';

export enum QualityScore {
  Poor,
  Suboptimal,
  Good,
  Excellent,
}

export function Quality() {
  const { state } = useAppStateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const preflightReport = state.networkTestResult?.results.preflight;
  const { latency, jitter, packetLoss } = getQualityScore((preflightReport as PreflightTestReport) || null);
  const quality = preflightReport?.callQuality || PreflightTest.CallQuality.Excellent;

  return (
    <>
      <QualityModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        jitter={jitter}
        latency={latency}
        packetLoss={packetLoss}
      />
      {quality === PreflightTest.CallQuality.Fair || quality === PreflightTest.CallQuality.Degraded ? (
        <PoorQuality openModal={() => setIsModalOpen(true)} />
      ) : (
        <ExcellentQuality openModal={() => setIsModalOpen(true)} quality={quality} />
      )}
    </>
  );
}
